export interface VenueMapping {
  label: string
}

export enum MPID {
  ALLQ = 'ALLQ', // Bloomberg ALLQ
  BDDK = 'BDDK',
  BIGP = 'BIGP',
  BMBW = 'BMBW', // Bloomberg MBW
  BMTF = 'BMTF', // Bloomberg MTF (UK)
  BTBS = 'BTBS', // Bloomberg Tradebook Singapore
  BTFE = 'BTFE', // Bloomberg MTF (EU)
  VCON = 'VCON', // Bloomberg VCON
  CDRG = 'CDRG',
  CSIN = 'CSIN',
  GSCO = 'GSCO',
  HEAD = 'HEAD',
  JPMS = 'JPMS',
  JSCA = 'JSCA',
  MADV = 'MADV',
  MKAA = 'MKAA',
  MKTX = 'MKTX',
  MMNT = 'MMNT',
  MSCO = 'MSCO',
  NICD = 'NICD',
  NITE = 'NITE',
  OYLD = 'OYLD',
  PACT = 'PACT',
  RBCD = 'RBCD',
  TMCC = 'TMCC',
  TMID = 'TMID',
  TWDA = 'TWDA',
  TWDI = 'TWDI',
  VABD = 'VABD',
}
